// src/pages/NotFound.tsx
import React from 'react';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div style={{ textAlign: 'center', padding: '64px 0' }}>
      <h1 style={{ fontSize: 72, color: '#ff4d4f', marginBottom: 24 }}>404</h1>
      <div style={{ fontSize: 24, marginBottom: 16 }}>
        很抱歉，页面未找到
      </div>
      <div style={{ color: '#888', marginBottom: 32 }}>
        您访问的页面不存在或已被删除。
      </div>
      <Button type="primary" size="large" onClick={() => navigate('/')}>
        返回首页
      </Button>
    </div>
  );
};

export default NotFound;
